/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import Helmet from "react-helmet"
import { useStaticQuery, graphql } from "gatsby"

function Seo({ description, lang, meta, title, nofollow, canonical, image, imageAlt, imageWidth, imageHeight, imageType }) {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            twitter
            image
            imageAlt
            imageHeight
            imageWidth
            imageType
          }
        }
      }
    `
  )

  const baseUrl = "https://ulae.com";
  const metaDescription = description || site.siteMetadata.description
  const twCard = (image) ? "summary_large_image" : "summary";
  const ogImage = (image) ? baseUrl + image.src : baseUrl + site.siteMetadata.image;
  const ogImageAlt = imageAlt || site.siteMetadata.imageAlt;
  const ogImageHeight = (image) ? image.presentationHeight : site.siteMetadata.imageHeight;
  const ogImageWidth =  (image) ? image.presentationWidth : site.siteMetadata.imageWidth;
  const ogImageType = imageType || (image === "site.siteMetadata.image") ? site.siteMetadata.imageType : "image/jpeg";
  const canonicalUrl = baseUrl + canonical;


  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={title}
      titleTemplate={`%s | ${site.siteMetadata.title}`}
      link={(canonical) && [{rel: `canonical`, href: canonicalUrl}]}
      meta={[ 
        {
          property: `og:locale`,
          content: `en_US`,
        },
        {
          property: `og:url`,
          content: canonical,
        },
        {
          property: `og:type`,
          content: `article`,
        },
        {
          property: `article:publisher`,
          content: `https://www.facebook.com/ulaestudio/`,
        },
        {
          property: `og:title`,
          content: title,
        },
        {
          property: `og:description`,
          content: metaDescription,
        },
        {
          property: `og:image`,
          content: ogImage,
        },
        {
          property: `og:image:alt`,
          content: ogImageAlt,
        },
        {
          property: `og:image:secure_url`,
          content: ogImage,
        },
        {
          property: `og:image:type`,
          content: ogImageType,
        },
        {
          property: `og:image:width`,
          content: ogImageWidth,
        },
        {
          property: `og:image:height`,
          content: ogImageHeight,
        },
        {
          property: `og:site_name`,
          content: "Universal Limited Art Editions (ULAE)",
        },
        
        {
          name: `twitter:card`,
          content: twCard,
        },
        {
          name: `twitter:site`,
          content: site.siteMetadata.twitter,
        },
        {
          name: `twitter:creator`,
          content: site.siteMetadata.twitter,
        },
        {
          name: `twitter:title`,
          content: title,
        },
        {
          name: `twitter:description`,
          content: metaDescription,
        },
        {
          name: `twitter:image`,
          content: ogImage,
        },
        {
          name: `description`,
          content: metaDescription,
        },{
          name: `copyright`,
          content: `© 2019 Universal Limited Art Editions. All rights reserved.`,
        },
      ]
        .concat(
          nofollow === true
            ? {
                name: `robots`,
                content: "noindex, nofollow",
              }
            : []
        )
        .concat(meta)}
    />
  )
}

export function SEOProperties(descriptionText, imageNode, imageAlt)
{
  const description = descriptionText || null;

  return {
    description: description,
    image: imageNode.src,
    imageAlt: imageAlt,
    imageHeight: imageNode.presentationHeight,
    imageWidth: imageNode.presentationWidth
  }
}

Seo.defaultProps = {
  lang: `en`,
  meta: [],
  keywords: [],
  description: ``,
}

Seo.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  keywords: PropTypes.arrayOf(PropTypes.string),
  title: PropTypes.string.isRequired,
}

export default Seo
